export default class EstatedMortgage {
  constructor(obj) {
    this.fips = obj.fips;
    this.apn = obj.apn;
    this.book_number = obj.book_number;
    this.page_number = obj.page_number;
    this.document_number = obj.document_number;
    this.original_contract_date = obj.original_contract_date;
    this.recording_date = obj.recording_date;
    this.borrower_first_name = obj.borrower_first_name;
    this.borrower_last_name = obj.borrower_last_name;
    this.borrower_entity_type = obj.borrower_entity_type;
    this.borrower2_first_name = obj.borrower2_first_name;
    this.borrower2_last_name = obj.borrower2_last_name;
    this.borrower2_entity_type = obj.borrower2_entity_type;
    this.borrower_vesting_type = obj.borrower_vesting_type;
    this.borrower_address = obj.borrower_address;
    this.borrower_unit_number = obj.borrower_unit_number;
    this.borrower_city = obj.borrower_city;
    this.borrower_state = obj.borrower_state;
    this.borrower_zip_code = obj.borrower_zip_code;
    this.borrower_zip_plus_four_code = obj.borrower_zip_plus_four_code;
    this.lender_legal_name = obj.lender_legal_name;
    this.lender_type = obj.lender_type;
    this.lender_dba_name = obj.lender_dba_name;
    this.lender_address = obj.lender_address;
    this.lender_unit_number = obj.lender_unit_number;
    this.lender_city = obj.lender_city;
    this.lender_state = obj.lender_state;
    this.lender_zip_code = obj.lender_zip_code;
    this.lender_zip_plus_four_code = obj.lender_zip_plus_four_code;
    this.title_insurance_company_name = obj.title_insurance_company_name;
    this.loan_amount = obj.loan_amount;
    this.loan_type = obj.loan_type;
    this.loan_term_months = obj.loan_term_months;
    this.loan_number = obj.loan_number;
    this.finance_type = obj.finance_type;
    this.interest_rate = obj.interest_rate;
    this.due_date = obj.due_date;
    this.adjustable_interest_rate_index_type =
      obj.adjustable_interest_rate_index_type;
    this.margin_interest = obj.margin_interest;
    this.interest_rate_change_frequency_months =
      obj.interest_rate_change_frequency_months;
    this.interest_rate_max_on_first_change =
      obj.interest_rate_max_on_first_change;
    this.interest_rate_min_on_first_change =
      obj.interest_rate_min_on_first_change;
    this.max_interest_rate = obj.max_interest_rate;
    this.interest_only_term_months = obj.interest_only_term_months;
    this.initial_interest_rate_type = obj.initial_interest_rate_type;
    this.adjustable_interest_rate_start_date =
      obj.adjustable_interest_rate_start_date;
    this.prepayment_forbiddance_term_months =
      obj.prepayment_forbiddance_term_months;
  }

  get primaryBuyerName() {
    return `${this.borrower_first_name} ${this.borrower_last_name}`;
  }
}
